import axios from 'axios';

const BASE_URL = "https://erpnext.api.esoftech.com/api"; 
//const BASE_URL = "http://localhost:5131/api"; 


const handleError = (error) => {
  if (error.response) {
    console.error('Error during file upload:', error.response.data.message || error.response.data);
  } else if (error.request) {
    console.error('No response received:', error.request);
    console.error('Request details:', error.request);
  } else {
    console.error('Error:', error.message || error);
  }
};

// Helper function for file upload
const uploadFile = async (endpoint, file) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await axios.post(`${BASE_URL}${endpoint}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response.status === 200) {
      console.log('File uploaded successfully');
      return response.data;
    } else {
      console.error('Failed to upload file:', response.data.message || 'Unknown error');
      throw new Error(response.data.message || 'Unknown error');
    }
  } catch (error) {
    handleError(error);
    throw error;
  }
};

// Upload Amazon Excel
export const uploadAmazonExcel = async (file) => {
  return uploadFile('/ExcelImport/AmazonExcel', file);
};

// Upload Meesho Excel
export const uploadMeeshoExcel = async (file) => {
  return uploadFile('/ExcelImport/MeeshoExcel', file);
};
// Upload FlipKart Excel
export const uploadFlipKartExcel = async (file) => {
  return uploadFile('/ExcelImport/FlipKartExcel', file);
};

// Create Sales Invoice
export const createSalesInvoice = async () => {
  try {
    const response = await axios.post(`${BASE_URL}/InvoiceOrder/CreateSalesInvoice`);
    return response.data;
  } catch (error) {
    console.error("Error creating sales invoice:", error);
    throw error;
  }
};

// Recreate Sales Invoice
export const recreateSalesInvoice = async () => {
  try {
    const response = await axios.post(`${BASE_URL}/InvoiceOrder/ReCreateSalesInvoice`);
    return response.data;
  } catch (error) {
    console.error("Error recreating sales invoice:", error);
    throw error;
  }
};
